import React from 'react';

export default class InfoBarBase extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <div className={this.props.className}>
        <ul id="sparks">
          {data && data.length > 0 && data.map((el, i) => (
          <li className="sparks-info" key={i}>
            <h5>{el.title}<span className="txt-color-blue">{el.value}</span></h5>
          </li>
          ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/InfoBarBase.js